import { connect } from 'react-redux';
import { compose } from 'recompose';

import BooksPage from './BooksPage';

const mapStateToProps = state => ({
    data: state,
});

export default compose(
    connect(mapStateToProps),
)(BooksPage);
